import FreeShippingBanner from 'components/Banner/FreeShippingBanner/FreeShippingBanner.f';

export default FreeShippingBanner;
